import React, { useState } from "react";
import ModalSkeleton from "../ModalSkeleton";
import classes from "./EditProfileModal.module.css";
import TextArea from "../../Component/TextArea";
import { RxCross2 } from "react-icons/rx";
import { Input } from "../../Component/Input/Input";
import { Button } from "../../Component/Button/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  apiHeader,
  BaseURL,
  capitalizeFirstLetter,
  formRegEx,
  formRegExReplacer,
} from "../../config/apiUrl";
import { Patch } from "../../Axios/AxiosFunctions";
import { toast } from "react-toastify";
import { ProfileWithEditButton } from "../../Component/ProfileWithEditButton";
import { updateUser } from "../../store/auth/authSlice";
const EditProfileModal = ({ show, setShow }) => {
  const { access_token, user } = useSelector((state) => state?.authReducer);

  const [userName, setUserName] = useState("" || user?.userName);

  const [isLoading, setIsLoading] = useState(false);
  const [img, setImg] = useState(undefined || user?.photo);

  const [active, setactive] = useState("original");
  const dispatch = useDispatch();
  const updatePassword = async () => {
    const url = BaseURL("users/updateme");
    const params = {
      userName: userName,
      photo: img,
    };
    const formData = new FormData();
    for (let key in params) {
      if (params[key] === "" || params[key] === null)
        return toast.error(
          `${capitalizeFirstLetter(
            key?.replace(formRegEx, formRegExReplacer)
          )} can not be empty.`
        );
      formData.append(key, params[key]);
    }

    setIsLoading(true);
    const response = await Patch(url, formData, apiHeader(access_token));

    if (response) {
      toast.success("Profile Succesfully Updated");
      setShow(false);
      dispatch(updateUser(response?.data?.data?.user));
    }
    setIsLoading(false);
  };
  return (
    <div>
      <ModalSkeleton
        setShow={setShow}
        show={show}
        width={"689px"}
        //   header={"Login"}
        borderRadius={"20px"}
        //   showCloseIcon
      >
        <div className={classes.main}>
          <div className={classes.header}>
            <div className="mb-4">
              <ProfileWithEditButton
                updateImage={img}
                setUpdateImage={setImg}
              />
            </div>
            <div
              className={[
                classes.btn,
                active === "original" && classes.active,
              ].join(" ")}
              onClick={() => {
                setactive("original");
              }}
            >
              <div className={classes.input_main}>
                <Input
                  value={userName}
                  setter={setUserName}
                  placeholder={"User Name"}
                />

                <Button
                  onClick={updatePassword}
                  green
                  customStyle={{ width: "100%" }}
                  label={isLoading ? "Updating..." : "Update"}
                />
              </div>
            </div>
          </div>
          {/* <div
            className={classes.crossBtn}
            onClick={() => {
              setShow(false);
            }}
          >
            <RxCross2 size={20} color={"var(--white-color"} />
          </div> */}
        </div>
      </ModalSkeleton>
    </div>
  );
};

export default EditProfileModal;
